import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { database } from '../../Firebase';
import { ref, onValue, remove } from 'firebase/database';

const Milakhatnondani = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [records, setRecords] = useState([]);
  const [allRecords, setAllRecords] = useState([]); // Store all records for filtering
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  useEffect(() => {
    const recordsRef = ref(database, 'Grampanchayat/Gramniddhi/NewMilakhatRecords');

    const unsubscribe = onValue(recordsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        // Convert object to array
        const recordsArray = Object.keys(data).map(key => ({
          id: key, // key is propertyNo
          ...data[key]
        }));
        setAllRecords(recordsArray);
        setRecords(recordsArray);
      } else {
        setAllRecords([]);
        setRecords([]);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setRecords(allRecords);
      return;
    }

    const filtered = allRecords.filter(record =>
      record.propertyNo.toString().includes(searchTerm) ||
      (record.mainOwner && record.mainOwner.includes(searchTerm))
    );
    setRecords(filtered);
  };

  // Live search effect
  useEffect(() => {
    if (!searchTerm.trim()) {
      setRecords(allRecords);
    } else {
      const filtered = allRecords.filter(record =>
        record.propertyNo.toString().includes(searchTerm) ||
        (record.mainOwner && record.mainOwner.includes(searchTerm))
      );
      setRecords(filtered);
    }
  }, [searchTerm, allRecords]);

  const handleNewClick = () => {
    navigate('/newmilakhatregister');
  };

  const handleEdit = (record) => {
    navigate('/newmilakhatregister', { state: { record } });
  };

  const handleView = (record) => {
    setSelectedRecord(record);
    setIsViewModalOpen(true);
  };

  const handleDelete = async (record) => {
    if (window.confirm(`नक्की तुम्हाला ${record.propertyNo} मिळकत क्रमांक हटवायचा आहे का?`)) {
      try {
        const recordRef = ref(database, `Grampanchayat/Gramniddhi/NewMilakhatRecords/${record.propertyNo}`);
        await remove(recordRef);
        alert('मिळकत यशस्वीरित्या हटवली गेली.');
      } catch (error) {
        console.error("Error deleting record:", error);
        alert('हटवताना त्रुटी आली. कृपया पुन्हा प्रयत्न करा.');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#267c77] to-[#267c77] text-white p-4 shadow-lg">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold">मिळकत माहिती</h1>
          <button
            onClick={handleNewClick}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded-lg shadow transition-colors duration-200 flex items-center space-x-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span>नविन</span>
          </button>
        </div>
      </div>

      {/* Advance Search Section */}
      <div className="bg-[#267c77] border-b border-blue-200">
        <div className="max-w-7xl mx-auto p-4">
          <div className="flex items-center space-x-3">
            <input
              type="checkbox"
              id="advanceSearch"
              checked={showAdvanceSearch}
              onChange={(e) => setShowAdvanceSearch(e.target.checked)}
              className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
            />
            <label htmlFor="advanceSearch" className="text-white-800 font-medium select-none cursor-pointer">
              अधिक शोध (Advance Search)
            </label>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto p-4">
          <div className="flex space-x-4">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="मिळकत क्रमांक / मिळकत धारकाचे नाव"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-[#267c77]"
            />
            <button
              onClick={handleSearch}
              className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded-lg shadow transition-colors duration-200 flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <span>शोधणे</span>
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="max-w-7xl mx-auto p-4">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-[#267c77] text-white">
                  <th className="px-4 py-3 text-left text-sm font-semibold border border-blue-700">
                    मिळकत नं.
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold border border-blue-700">
                    मालकाचे नाव
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold border border-blue-700">
                    वार्डचे नाव
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold border border-blue-700">
                    मिळकत प्रकार
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-semibold border border-blue-700">
                    पर्याय
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {records.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-6 py-12 text-center text-gray-500 border border-gray-200">
                      <div className="flex flex-col items-center space-y-2">
                        <span className="text-lg font-medium">No records found</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  records.map((record) => (
                    <tr key={record.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-900 border border-gray-200">
                        {record.propertyNo}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 border border-gray-200">
                        {record.mainOwner}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 border border-gray-200">
                        {record.wardName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 border border-gray-200">
                        {/* Display first property type or generic info */}
                        {record.propertyRecords && record.propertyRecords.length > 0
                          ? record.propertyRecords[0].propertyType
                          : 'N/A'}
                        {record.propertyRecords && record.propertyRecords.length > 1 &&
                          <span className="text-xs text-[#267c77] ml-1">(+{record.propertyRecords.length - 1} more)</span>
                        }
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 border border-gray-200">
                        <div className="flex justify-center space-x-1">

                          {/* Edit Button */}
                          <button 
                            onClick={() => handleEdit(record)}
                            className="flex flex-col items-center justify-center bg-[#246c67] text-white px-2 py-1 rounded text-xs hover:bg-[#1a4d4a]" 
                            title="संपादित करा"
                          >
                            <svg className="w-4 h-4 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
                            <span>बदल</span>
                          </button>

                          {/* View Button */}
                          <button 
                            onClick={() => handleView(record)}
                            className="flex flex-col items-center justify-center bg-green-600 text-white px-2 py-1 rounded text-xs hover:bg-green-700" 
                            title="पाहणे"
                          >
                            <svg className="w-4 h-4 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                            <span>पाहणे</span>
                          </button>

                          {/* Delete Button */}
                          <button 
                            onClick={() => handleDelete(record)}
                            className="flex flex-col items-center justify-center bg-red-600 text-white px-2 py-1 rounded text-xs hover:bg-red-700" 
                            title="हटवा"
                          >
                            <svg className="w-4 h-4 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                            <span>खोडणे</span>
                          </button>

                          {/* Namuna 8 - Opens Report in New Tab */}
                          <button
                            onClick={() => window.open(`/namuna8/${record.id}`, '_blank')}
                            className="flex flex-col items-center justify-center bg-[#267c77] text-white px-2 py-1 rounded text-xs hover:bg-[#267c77]"
                            title="नमुना ८"
                          >
                            <svg className="w-4 h-4 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                            <span>नमुना ८</span>
                          </button>

                          {/* Namuna 9 - Opens Report in New Tab */}
                          <button
                            onClick={() => window.open(`/namuna9/${record.id}`, '_blank')}
                            className="flex flex-col items-center justify-center bg-[#267c77] text-white px-2 py-1 rounded text-xs hover:bg-[#267c77]"
                            title="नमुना ९"
                          >
                            <svg className="w-4 h-4 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                            <span>नमुना ९</span>
                          </button>

                          {/* Tax Bill - Opens Report in New Tab */}
                          <button
                            onClick={() => window.open(`/taxbill/${record.id}`, '_blank')}
                            className="flex flex-col items-center justify-center bg-[#267c77] text-white px-2 py-1 rounded text-xs hover:bg-[#267c77]"
                            title="कर बिल"
                          >
                            <svg className="w-4 h-4 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                            <span>कर बिल</span>
                          </button>

                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* View Modal */}
      {isViewModalOpen && selectedRecord && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-[#267c77] text-white p-4 flex justify-between items-center sticky top-0">
              <h2 className="text-xl font-bold">मिळकत माहिती तपशील - {selectedRecord.propertyNo}</h2>
              <button 
                onClick={() => setIsViewModalOpen(false)}
                className="hover:bg-[#1a4d4a] p-1 rounded-full transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            
            <div className="p-6 space-y-6">
              {/* Basic Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <h3 className="text-lg font-bold border-b pb-1 text-[#267c77]">प्राथमिक माहिती</h3>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <span className="font-semibold text-gray-600">मिळकत क्रमांक:</span>
                    <span>{selectedRecord.propertyNo}</span>
                    <span className="font-semibold text-gray-600">मुख्य मालक:</span>
                    <span>{selectedRecord.mainOwner}</span>
                    <span className="font-semibold text-gray-600">मालकाची पत्नी:</span>
                    <span>{selectedRecord.mainOwnerWife || 'नाही'}</span>
                    <span className="font-semibold text-gray-600">वार्ड:</span>
                    <span>{selectedRecord.wardName}</span>
                    <span className="font-semibold text-gray-600">विभाग:</span>
                    <span>{selectedRecord.divisionType}</span>
                  </div>
                </div>

                <div className="space-y-4">
                  <h3 className="text-lg font-bold border-b pb-1 text-[#267c77]">पत्ता तपशील</h3>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <span className="font-semibold text-gray-600">रस्ता:</span>
                    <span>{selectedRecord.roadName || 'नाही'}</span>
                    <span className="font-semibold text-gray-600">सिटी सर्व्हे क्र.:</span>
                    <span>{selectedRecord.citySurveyNo || 'नाही'}</span>
                  </div>
                </div>
              </div>

              {/* Multiple Owners */}
              {selectedRecord.owners && selectedRecord.owners.length > 0 && (
                <div className="space-y-3">
                  <h3 className="text-lg font-bold border-b pb-1 text-[#267c77]">इतर मालक</h3>
                  <div className="overflow-x-auto border rounded-lg">
                    <table className="w-full text-sm">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-4 py-2 text-left">नाव</th>
                          <th className="px-4 py-2 text-left">मोबाईल</th>
                          <th className="px-4 py-2 text-left">आधार</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRecord.owners.map((owner, idx) => (
                          <tr key={idx} className="border-t">
                            <td className="px-4 py-2">{owner.name}</td>
                            <td className="px-4 py-2">{owner.mobileNumber}</td>
                            <td className="px-4 py-2">{owner.aadharNumber}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Tax Details */}
              {selectedRecord.taxData && (
                <div className="space-y-3">
                  <h3 className="text-lg font-bold border-b pb-1 text-[#267c77]">कर तपशील</h3>
                  <div className="overflow-x-auto border rounded-lg">
                    <table className="w-full text-sm">
                      <thead className="bg-gray-50 text-center">
                        <tr>
                          <th className="px-4 py-2 text-left">कर प्रकार</th>
                          <th className="px-4 py-2">मागील</th>
                          <th className="px-4 py-2">चालू</th>
                          <th className="px-4 py-2">एकूण</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        <tr className="border-t">
                          <td className="px-4 py-2 text-left">घरपट्टी</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.houseTax.previous}</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.houseTax.current}</td>
                          <td className="px-4 py-2 font-bold">{selectedRecord.taxData.houseTax.total}</td>
                        </tr>
                        <tr className="border-t">
                          <td className="px-4 py-2 text-left">विज कर</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.electricityTax.previous}</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.electricityTax.current}</td>
                          <td className="px-4 py-2 font-bold">{selectedRecord.taxData.electricityTax.total}</td>
                        </tr>
                        <tr className="border-t">
                          <td className="px-4 py-2 text-left">आरोग्य कर</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.healthTax.previous}</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.healthTax.current}</td>
                          <td className="px-4 py-2 font-bold">{selectedRecord.taxData.healthTax.total}</td>
                        </tr>
                        <tr className="border-t bg-gray-50 font-bold">
                          <td className="px-4 py-2 text-left">एकूण</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.total.previous}</td>
                          <td className="px-4 py-2">{selectedRecord.taxData.total.current}</td>
                          <td className="px-4 py-2 text-[#267c77]">{selectedRecord.taxData.total.total}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            
            <div className="p-4 bg-gray-50 border-t flex justify-end">
              <button 
                onClick={() => setIsViewModalOpen(false)}
                className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg font-bold transition-colors"
              >
                बंद करा
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Milakhatnondani;